import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41d45348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full negative-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Apartados", -1))
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header border-0 pt-0 px-0" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mt-2" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_11 = { class: "col-sm-2 col-md-2 col-lg-2 col-xs-12 mt-2" }
const _hoisted_12 = {
  key: 0,
  class: "col-sm-2 col-md-2 col-lg-2 col-xs-12 mt-2 pe-1"
}
const _hoisted_13 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mt-2 mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end",
    "data-kt-subscription-table-toolbar": "base"
  })
], -1))
const _hoisted_15 = { class: "card-body pt-0 px-0" }
const _hoisted_16 = {
  src: "media/icons/iconsax/blue_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_17 = {
  src: "media/icons/iconsax/red_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_18 = {
  src: "media/icons/iconsax/green_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sin resultados")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "row align-items-center py-3 px-3 m-0 border border-top-0 border-gray-600 rounded-bottom bg-gray footer-position-table"
}
const _hoisted_24 = { class: "col-sm-12 col-md-6 mb-3 mb-md-0 d-flex flex-row align-items-center fs-sm" }
const _hoisted_25 = { class: "me-2" }
const _hoisted_26 = { class: "col-sm-12 col-md-6 text-end fs-sm" }
const _hoisted_27 = {
  id: "kt_referre_dusers_tab_content_pagination",
  class: "tab-content"
}
const _hoisted_28 = { class: "pagination justify-content-end" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "page-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.total == 1 ? " Registro" : " Registros"), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/duotune/general/gen021.svg",
                    class: "lineH"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "data-kt-subscription-table-filter": "search",
                  class: "form-control form-control-solid ps-14 fs-base inputSearch ms-2 me-0",
                  placeholder: "Buscar",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buscar) = $event)),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchDebouncer && _ctx.searchDebouncer(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.buscar]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Field, {
                  name: "Estatus",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible",
                  modelValue: _ctx.estatusApartado,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.estatusApartado) = $event))
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "Estatus",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.setEstatus
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "Estatus",
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Estatus")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.status,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.tipoRol == 'Corporativo')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (!_ctx.sub)
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 0,
                          name: "Agencia",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible",
                          modelValue: _ctx.searchByAgency,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchByAgency) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              name: "Agencia",
                              value: value,
                              "model-value": value,
                              "onUpdate:modelValue": handleChange,
                              loading: _ctx.loading,
                              size: "large",
                              onChange: _ctx.searchCatsAgency
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "Agencia",
                                  selected: true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Agencia")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agenciesCat, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.nombre,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_DateRange, {
                  onGetDates: _ctx.getDates,
                  class: _normalizeClass('apartados')
                }, null, 8, ["onGetDates"])
              ])
            ])
          ])
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData1,
          loading: _ctx.loading,
          "table-header": _ctx.headerConfig,
          "enable-items-per-page-dropdown": false,
          rowsPerPage: parseInt(_ctx.showing)
        }, _createSlots({
          "cell-cliente": _withCtx(({ row: customer }) => [
            _withDirectives(_createVNode(_component_router_link, {
              class: "text-white text-hover-primary mb-1",
              to: { name: 'apartados-detail', params: { uuid: customer.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(customer.cliente), 1)
              ]),
              _: 2
            }, 1032, ["to"]), [
              [_vShow, _ctx.$can('Ver detalle de agencia')]
            ])
          ]),
          "cell-correo": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.correo), 1)
          ]),
          "cell-telefono": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.telefono), 1)
          ]),
          "cell-estatus": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                [_vShow, customer.estatus === 'Retenido']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
                [_vShow, customer.estatus === 'Devuelto']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                [_vShow, customer.estatus === 'Confirmado']
              ]),
              _createTextVNode(" " + _toDisplayString(customer.estatus), 1)
            ])
          ]),
          "cell-fecha": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.fecha), 1)
          ]),
          "cell-vehiculo": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.vehiculo), 1)
          ]),
          "cell-actions": _withCtx(({ row: customer }) => [
            _hoisted_19
          ]),
          _: 2
        }, [
          (_ctx.tipoRol == 'Corporativo')
            ? {
                name: "cell-agencia",
                fn: _withCtx(({ row: customer }) => [
                  _createElementVNode("div", null, _toDisplayString(customer.agencia), 1)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["table-data", "loading", "table-header", "rowsPerPage"]),
        (_ctx.noResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
          : _createCommentVNode("", true),
        (_ctx.total > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("span", _hoisted_25, "Elementos por página:", 512), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createVNode(_component_Field, {
                  name: "pages",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible w-75p pageNumber",
                  modelValue: _ctx.showing,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showing) = $event))
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      name: "pages",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      class: _normalizeClass([_ctx.pageNumber, "w-75px"]),
                      onChange: _ctx.showingSet
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 10,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("10")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 25,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("25")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 50,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("50")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs-_ctx.sm),
                          value: 100,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("100")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "class", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createElementVNode("span", { class: "w-25" }, " " + _toDisplayString(_ctx.from) + " - " + _toDisplayString(_ctx.to) + " de " + _toDisplayString(_ctx.total), 513), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("div", _hoisted_27, [
                  _createElementVNode("ul", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (lin, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass([
                  lin ? 'page-item' : '',
                  lin.active ? 'active' : '',
                  lin.url == null ? 'disabled' : '',
                ]),
                        onClick: ($event: any) => (_ctx.getPagination(lin))
                      }, [
                        (lin.url != null)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_30, _toDisplayString(lin.label.includes("Anterior")
                      ? "<"
                      : lin.label.includes("Siguiente")
                      ? ">"
                      : lin.label), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_29))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}